import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { useStore } from "@store/store";
import Loader from "@components/loader";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIcon from "@assets/images/checked-icon.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { permissionInfo, actionPermission } from "@utils/constant";
import { TableStyle } from "./style";

const listAction = [
  { key: 1, value: 'Read Only' },
  { key: 3, value: 'Read and Write' },
  { key: 7, value: 'Read, Write and Delete' }
]

const listActionFullPermission = [
  { key: 7, value: 'Read, Write and Delete' }
]
// list ids of permission can choose action permission
const listPermissionAction = [
  permissionInfo.JOB.id,
  permissionInfo.CARGO_WISE.id,
  permissionInfo.CONNECTED_CUSTOMER.id
];

const PermissionTableListing = React.memo(function PermissionTableListing(props) {
  const [state] = useStore();
  const classes = TableStyle();
  const [scroll] = useState("body");
  const materilClasses = materialCommonStyles();
  const handleChangePermission = (data, event) => {
    event.stopPropagation();
    props.handleChange(data, event);
  }
  return (
    <>
      <Dialog
        open={props.open}
        className={classes.customModal}
        scroll={scroll}
        onClose={props.handleClose}
      >
        <Loader
          loading={state?.connectedUser?.customersInConnectedUserLoading}
        />
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="check-box"></TableCell>
                <TableCell className="role-name">Permission</TableCell>
                <TableCell className="permission">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.listPermission.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3}>No Data Found</TableCell>
                </TableRow>
              ) : (
                props.listPermission.map((item, index) => {
                  const valueAction = props.permissionInfoData?.get(item.value);
                  if (item.value === permissionInfo.CARGO_WISE.id) {
                    return (
                      <TableRow
                        key={item.value ?? index}
                      >
                        <TableCell className="check-box">
                        </TableCell>
                        <TableCell className="role-name">{item.label}</TableCell>
                        <TableCell className="permission">
                          <FormControl
                            variant="outlined"
                            sx={{ m: 1, minWidth: 120 }}
                            disabled={valueAction === undefined}
                          >
                            <Select
                              value={valueAction ?? actionPermission.ALL}
                              onChange={(event) => {
                                handleChangePermission({
                                  id: item.value,
                                  permissionAction: event.target.value,
                                  isRemovePermission: false
                                }, event);
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                              displayEmpty
                              className={classes.actionDropdown}
                              MenuProps={{
                                classes: { paper: materilClasses.customSelect },
                              }}
                              IconComponent={() => <ExpandMore />}
                            >
                              {listAction.map(item => {
                                return (<MenuItem
                                  key={item.key}
                                  value={item.key}
                                  className={classes.actionMenuItem}
                                >
                                  {item.value}
                                </MenuItem>)
                              })
                              }
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    )
                  } else
                    return (
                      <TableRow
                        key={item.value ?? index}
                        onClick={(event) => {
                          handleChangePermission({
                            id: item.value,
                            permissionAction: actionPermission.ALL,
                            isRemovePermission: valueAction !== undefined
                          }, event);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <TableCell className="check-box">
                          <Checkbox
                            checked={valueAction !== undefined}
                            icon={<img src={uncheckedIcon} alt="CheckBox" />}
                            checkedIcon={<img src={checkedIcon} alt="CheckBox" />}
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                            onChange={(event) => {
                              handleChangePermission({
                                id: item.value,
                                permissionAction: actionPermission.ALL,
                                isRemovePermission: valueAction !== undefined
                              }, event);
                            }}
                          />
                        </TableCell>
                        <TableCell className="role-name">{item.label}</TableCell>
                        <TableCell className="permission">
                          <FormControl
                            variant="outlined"
                            sx={{ m: 1, minWidth: 120 }}
                            disabled={valueAction === undefined}
                          >
                            <Select
                              value={valueAction ?? actionPermission.ALL}
                              onChange={(event) => {
                                handleChangePermission({
                                  id: item.value,
                                  permissionAction: event.target.value,
                                  isChangeAction: true,
                                  isRemovePermission: false
                                }, event);
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                              displayEmpty
                              className={classes.actionDropdown}
                              MenuProps={{
                                classes: { paper: materilClasses.customSelect },
                              }}
                              IconComponent={() => <ExpandMore />}
                            >
                              {
                                (listPermissionAction.includes(item.value) ? listAction : listActionFullPermission)
                                  .map(item => {
                                    return (<MenuItem
                                      key={item.key}
                                      value={item.key}
                                      className={classes.actionMenuItem}
                                    >
                                      {item.value}
                                    </MenuItem>)
                                  })
                              }
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Dialog>
    </>
  );
})
export default PermissionTableListing;
